<template>
  <div style="padding: 20px; background: #fff">
    <h1 class="com-title com-ht tree-title" style="padding-top: 0">
      <i></i>
      <span class="ms">合同发起时审批 / 合同发起时的审批流程，审批通过后合同才能成功发送</span>
    </h1>
    <div class="shearch-lab">
      <el-button type="primary" size="small" plain @click="addFlow">新增审批</el-button>
      <el-form :inline="true" :model="createFilter" size="small">
        <el-form-item>
          <el-input style="width: 220px" v-model="createFilter.flowName" placeholder="流程名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 120px" v-model="createFilter.orderFlag" placeholder="请选择流程">
            <el-option label="全部类型" value></el-option>
            <el-option label="顺序审批" :value="1"></el-option>
            <el-option label="会审" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 120px" v-model="createFilter.useStatus" placeholder="请选择状态">
            <el-option label="全部状态" value></el-option>
            <el-option label="启用中" :value="0"></el-option>
            <el-option label="已停用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-right:0px">
          <el-button size="small" @click="filterSearch(1)">查询</el-button>
          <el-button size="small" @click="restShearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="createTableData" style="width: 100%" border row-key="flowId">
      <el-table-column prop="flowName" label="流程名称" width="200"></el-table-column>
      <el-table-column prop="orderFlag" label="审批流程" min-width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.flowId === 0">发起合同时，无需进行任何审批即可发起，请谨慎使用！</span>
          <span v-else>
            {{
            `${scope.row.orderFlag === 1 ? "顺序审批：" : "会审："}${
            scope.row.allPartName ? scope.row.allPartName : '-'
            }
            `
            }}
          </span>
        </template>
      </el-table-column>
      <!-- 已授权成员 -->
      <el-table-column label="已授权成员" min-width="200">
        <template slot-scope="scope">
          <el-popover placement="top" trigger="hover" @show="moreUse(scope.row)">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>
                  已授权成员
                  <span style="color: #ec1c1c">
                    （{{
                    userNames.length + "人"
                    }}）
                  </span>
                </span>
              </div>
              <div class="tag-box">
                <el-tag
                  size="small"
                  type="danger"
                  v-for="user of userNames"
                  :key="user.corpUserId"
                  class="text item"
                >{{ user.userName }}</el-tag>
              </div>
            </el-card>
            <span slot="reference" class="point">{{ scope.row._scopeOfUse || "-" }}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.flowId === 0">--</span>
          <span v-else>
            {{scope.row.createTime}}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="useStatus" label="启用状态" width="100">
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.useStatus === 1
                  ? '#adadad'
                  : scope.row.useStatus === 0 || scope.row.flowId === 0
                  ? '#67C23A'
                  : '#Ec1c1c',
            }"
          >●&nbsp;</span>
          <span>
            {{
            scope.row.useStatus === 1
            ? "已停用"
            : scope.row.useStatus === 0 || scope.row.flowId === 0
            ? "启用中"
            : "已删除"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <div class="handle-wrap">
            <template v-if="scope.row.flowId !== 0">
              <p
                class="color-success"
                :class="{ 'dis-style': !haveAuth }"
                @click="addFlow(scope.row)"
              >编辑</p>
              <p
                class="color-success"
                :class="{ 'dis-style': !haveAuth }"
                @click="switchStatus(scope.row)"
              >{{ scope.row.useStatus === 1 ? "启用" : "停用" }}</p>
              <p
                class="color-success"
                :class="{
                'dis-style':
                  !haveAuth || (haveAuth && scope.row.useStatus !== 1),
              }"
              >
                <el-tooltip
                  v-if="scope.row.useStatus === 0"
                  effect="light"
                  content="流程启用中，不可删除"
                  placement="bottom-end"
                >
                  <span>删除</span>
                </el-tooltip>
                <span v-else @click="del(scope.row)">删除</span>
              </p>
            </template>
            <p
              :class="['color-success', { 'dis-style': !haveAuth }]"
              @click="scopeOfUse(scope.row)"
            >成员授权</p>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="pageation">
      <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="createFilter.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="createFilter.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="createFilter.pageTotal"
        />
        <el-go
          :page-size="createFilter.pageSize"
          :total="createFilter.pageTotal"
          @current-change="handleCurrentChange"
          style="margin-right: 5px"
        ></el-go>
      </el-col>
    </el-row>
    <!-- 授权范围 -->
    <el-dialog
      title="授权范围"
      :visible.sync="useDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="filterSearch"
    >
      <el-tabs v-model="actTabItem" @tab-click="handleTabClick">
        <el-tab-pane label="未授权成员" :name="CANUSE">
          <scope-use
            ref="canUseRef"
            v-if="useDialogVisible"
            :rowData="selectRow"
            @changAuth="changAuth"
          ></scope-use>
        </el-tab-pane>
        <el-tab-pane label="已授权成员" :name="USED">
          <un-scope-use
            ref="usedRef"
            v-if="useDialogVisible"
            :rowData="selectRow"
            @changAuth="changAuth"
          ></un-scope-use>
        </el-tab-pane>
      </el-tabs>
      <!-- <span slot="footer">
        <el-button size="small" @click="useDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="useDialogVisible = false">确 定</el-button>
      </span>-->
    </el-dialog>
  </div>
</template>

<script>
import ElGo from "@/components/go/Go";
import scopeUse from "./scopeUse.vue";
import unScopeUse from "./unScopeUse.vue";

// data
import { gantConf, getPermInfo } from "@/assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
// API
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
// Tool
import moment from "moment";

const CANUSE = 'canUse', USED = 'used';

export default {
  components: { ElGo, scopeUse, unScopeUse },
  data () {
    return {
      CANUSE,
      USED,
      useDialogVisible: false,
      selectRow: {},
      actTabItem: CANUSE,
      gantConf,
      createFilter: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        flowName: "",
        orderFlag: "",
        useStatus: ""
      },
      createTableData: [],
      userNames: [], // 使用范围名称数组
    };
  },
  methods: {
    /** 取消/授权 */
    changAuth (data) {
      const _this = this;
      if (data.auth === 1) return _this.AuthAPI(data)
      _this.$confirm('是否移出使用范围', '系统提示').then(() => {
        _this.AuthAPI(data)
      }).catch(() => { })
    },
    /** 取消授权/授权API */
    AuthAPI (data) {
      const _this = this
      ApiCorpMethods.FlowController.grantorRevokeFLow(data).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        _this.$message.success(res.description)
        _this.refreshUse(this.actTabItem)
      })
    },
    /** tabChange */
    handleTabClick (tabName) {
      this.refreshUse(tabName.name)
    },
    /** 刷新选择范围表格数据 */
    refreshUse (name) {
      if (name === CANUSE) {
        this.$refs.canUseRef.getCmSealUsers()
      }
      if (name === USED) {
        this.$refs.usedRef.getflowByUserPaged()
      }
    },
    /** 修改使用范围 */
    scopeOfUse (row) {
      const bool = this.permsEven(),_this=this;
      if (!bool) {
        return false
      }
      _this.selectRow = row
      _this.useDialogVisible = true
      _this.$nextTick(()=>{
        _this.refreshUse(_this.actTabItem)
      })
    },
    /** 启用、停用 */
    async switchStatus (row) {
      const bool = this.permsEven()
      if (!bool) {
        // this.activeItem.useStatus
        return false
      }
      let param = {
        flowId: row.flowId,
        useStatus: row.useStatus === 0 ? 1 : row.useStatus === 1 ? 0 : 1
      }
      let res = await ApiCorpMethods.FlowController.switchFlow(param)
      if (res.success) {
        row.useStatus = param.useStatus
        this.$message.success((res.description || '操作成功'))
        // this.$message.success((res.description || '操作成功') + `, 已${!row.useStatus ? '启' : '停'}用`)
        // this.filterSearch()
      } else {
        this.$message.error(res.description || '操作失败，请重试')
      }
    },
    /** 删除 */
    del (row) {
      const bool = this.permsEven()
      if (!bool) return
      this.$confirm('是否删除审批流程', '系统提示').then(async () => {
        // 删除接口
        let res = await ApiCorpMethods.FlowController.delFlow({ flowId: row.flowId })
        if (res.success) {
          this.$message.success(res.description || '删除审批流程成功')
          this.filterSearch()
        } else {
          this.$message.error(res.description || '操作失败')
        }
      }).catch(() => { })
    },
    /** 权限验证 */
    permsEven (pid = gantConf.documentApproval) {
      const perms = this.perms;
      const bool = perms.includes(pid);
      if (!bool) {
        const Pinfo = getPermInfo(pid);
        this.$message.warning(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`);
      }
      return bool;
    },
    /** 页数切换 */
    handleCurrentChange (val) {
      this.createFilter.itemPage = val;
      this.queryCreate();
    },
    /** 每页条数change */
    handleSizeChange (val) {
      this.createFilter.itemPage = 1;
      this.createFilter.pageSize = val;
      this.queryCreate();
    },
    /** 发起审批 */
    addFlow (row) {
      //合同审批
      // 发起审批
      const bool = this.permsEven()
      if (!bool) return
      const query = { flowType: 0 }
      if (row) {
        query.flowId = row.flowId
        query.flowType = row.flowType
      }
      this.$router.push({
        path: "/console/approval",
        query
      });
    },
    /** 重置 */
    restShearch () {
      this.createFilter = {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        flowName: "",
        orderFlag: "",
        useStatus: "",
      };
      this.filterSearch();
    },
    /** 搜索按钮 */
    filterSearch (showToast) {
      this.createFilter.itemPage = 1;
      this.queryCreate({ showToast });
    },
    /** 查询合同审批 */
    async queryCreate (obj = {}) {
      const { showToast } = obj;
      this.createLoading = true
      let param = Object.assign({}, this.createFilter, { flowType: 0 });
      let res = await ApiCorpMethods.FlowController.pageFlow(param);
      if (!res.success) {
        return this.$message.error(res.description || "查询数据失败");
      }
      if (showToast && showToast === 1) this.$message.success('查询成功')
      let _data = res.data.map(i => {
        i.createTime = moment(i.createTime).format("YYYY-MM-DD");
        return i;
      });
      if(this.createFilter.useStatus === 1){
        _data= _data.filter(item=> item.flowId !== 0)
      }
      this.createTableData = _data
      this.createTableData.forEach((item, i) => {
        const _size = 15;
        ApiCorpMethods.FlowController.findflowByUserPaged({
          auth: 1,
          flowId: item.flowId,
          page: 1,
          pageSize: _size
        })
          .then(result => {
            let user = result.data.map(item => item.userName)
            if (result.total > _size) {
              user.push('...')
            }
            this.$set(this.createTableData[i], '_scopeOfUse', user.toString())
          })
      })
      this.createFilter.pageTotal = res.total;
      this.createFilter.pageSize = res.pageSize;
      this.createFilter.pageNum = res.pageNum;
      this.createFilter.pages = res.pages;
      this.createLoading = false
    },
    /** 查询使用范围数据 */
    moreUse (row) {
      const data = {
        auth: 1,
        flowId: row.flowId,
        page: 1,
        pageSize: 10000
      }, _this = this;
      ApiCorpMethods.FlowController.findflowByUserPaged(data).then(res => {
        if (!res.success) return this.$message.error(res.description)
        _this.userNames = res.data
      })
    },
  },
  computed: {
    ...mapGetters(["currentAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    haveAuth () {
      return this.perms.includes(gantConf.documentApproval);
    },
  },
  created () {
    this.queryCreate();
    // this.$nextTick(() => {
    //   this.operationAuthFn();
    // });
  },
};
</script>

<style scoped lang="less">
/deep/ .el-dialog__body {
  padding-top: 0;
}
.shearch-lab{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
}
.box-card {
  width: 40vw;
  padding: 5px;
  .text {
    font-size: 14px;
  }

  .item {
    margin: 0 5px 5px 0;
  }
  .tag-box {
    max-height: 20vh;
    padding: 5px;
    overflow: auto;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both;
  }
}
.handle-wrap {
  & > p {
    font-size: 14px;
    cursor: pointer;
    color: #290202;
    font-weight: bold;
  }

  .color-success:hover {
    color: #ec1c1c;
  }
  .dis-style {
    color: #ccc;
    cursor: not-allowed;
  }
}
</style>

<style lang="less">
nav.nav-bar {
  .el-badge__content.is-fixed {
    right: 0;
  }
}
.el-tabs--bottom .el-tabs__header.is-bottom {
  margin-top: 0;
}
.el-tabs__item {
  font-weight: bold;
  font-size: 15px;
  padding: 0 12px !important;
}
.el-tabs__active-bar {
  /*display: none;*/
  color: #ec1c1c;
  background-color: #ec1c1c;
}
.el-tabs__item.is-active {
  color: #ec1c1c;
}
.el-tabs__item:hover {
  color: #ec1c1c;
}
.el-tabs__nav-wrap::after {
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// pages/console/components/contractApproval/contractApproval.vue